module.exports = __webpack_public_path__ + "img/wifi-test1.f189ae5.png";